import { ContainerIcon } from "shared/ui/Icons";
import { Tooltip } from "shared/ui/Tooltip";
import styles from "./ContainerTooltip.module.scss";

export type ContainerTooltipProps = {
  containersSizeTypes: string[];
  containersAmount: number;
};

export const ContainerTooltip: RFC<ContainerTooltipProps> = ({ containersSizeTypes, containersAmount }) => {
  return (
    <Tooltip
      triggerElement={
        <div className={styles.containerAmount}>
          <span>{containersSizeTypes.length === 1 ? containersSizeTypes[0] : containersAmount}</span>
          <ContainerIcon className={styles.icon} />
        </div>
      }
      offsetY={15}
      disabled={!containersSizeTypes.length || containersSizeTypes.length === 1}
    >
      <ul className={styles.tooltipContainersList}>
        {containersSizeTypes.map((sizeType, index) => (
          <li className={styles.containerItem} key={index}>
            {sizeType}
          </li>
        ))}
      </ul>
    </Tooltip>
  );
};
